// extracted by mini-css-extract-plugin
export default {"homePage":"HomePage_homePage__oTAb+","fadeInUp":"HomePage_fadeInUp__oJINF"};